import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        const hash = window.location.hash;
        const sessionId = hash.split('session_id=')[1];
        if (!sessionId) {
          navigate('/auth');
          return;
        }

        // Exchange session_id for user data
        const res = await axios.post(`${API}/auth/session`, {
          session_id: sessionId
        }, { withCredentials: true });

        const userData = res.data;
        setUser(userData);

        // Set cookie via backend
        const sessionToken = sessionId;
        await axios.post(`${API}/auth/set-cookie`, {
          session_token: sessionToken
        }, { withCredentials: true });

        // Store token for Bearer auth
        localStorage.setItem('auth_token', sessionToken);

        navigate('/dashboard', { state: { user: userData } });
      } catch (err) {
        console.error('Auth callback error:', err);
        navigate('/auth');
      }
    };

    processAuth();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F9F7]" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-[#1A3C34] border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-sm text-[#737373]">Connexion en cours...</p>
      </div>
    </div>
  );
}
